class SupernovaHero extends window.BAO.CustomElement {
  constructor () {
    super()

    this.animateTitle = this.animateTitle.bind(this)

    this.animateTitle()
  }

  setupListeners () {
    super.setupListeners()

    this.els.trigger.elements.forEach(el => {
      this.listeners.add(el, 'click', this.scrollToSection.bind(this))
    })
  }

  animateTitle () {
    const title = this.els.title.element
    const titleText = title.dataset.text
    let i = 0

    title.innerHTML = ''

    const interval = window.setInterval(() => {
      title.innerText = titleText.substring(0, i)

      if (i++ > titleText.length) {
        this.els.button.elements.forEach(el =>
          el.setAttribute('aria-hidden', 'false')
        )
        document
          .querySelector('.sec-SupernovaNavigation')
          .setAttribute('aria-hidden', 'false')
        window.clearInterval(interval)
      }
    }, 75)
  }

  scrollToSection (e) {
    e.preventDefault()

    const target = this.closest('.shopify-section').nextElementSibling

    if (!target) return

    target.scrollIntoView({ behavior: 'smooth' })
  }
}

if (!customElements.get('supernova-hero')) {
  customElements.define('supernova-hero', SupernovaHero)
}
